// Preserves the Shopify embed query params (shop, host, embedded, ...)
// across client-side navigations so a page reload keeps the app embedded.
const PERSISTED_KEYS = ['shop', 'host', 'embedded', 'locale', 'id_token', 'session', 'timestamp', 'hmac'];

export default function persistSearch(to, extraParams = {}) {
  const params = new URLSearchParams(window.location.search);
  const search = new URLSearchParams();

  for (const key of PERSISTED_KEYS) {
    const value = params.get(key);
    if (value) search.set(key, value);
  }

  for (const [key, value] of Object.entries(extraParams)) {
    if (value !== undefined && value !== null && value !== '') {
      search.set(key, value);
    }
  }

  const searchString = search.toString();
  return searchString ? `${to}?${searchString}` : to;
}
